import React, { Component } from "react";

import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBRow,
    MDBCol,
    toast,
} from "mdbreact";

import { withTranslation } from "react-i18next";

import OperatorKeypoolsSubscribersTable from "../../../components/NetworkMgmt/Settings/Datatables/OperatorKeypoolsSubscribersTable";

import VenuesTable from "../../../components/NetworkMgmt/Settings/Datatables/OperatorKeypoolVenuesTable";

import {
    isR1Keypool,
    getR1ControllerNameForScope,
} from "../../../components/NetworkMgmt/Functions/getR1ControllerName";

import axios from "../../../axios";

class OperatorInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayOrder:
                this.props.keypoolInfo[this.props.keyPoolID]["DisplayOrder"],
            update_keypool: false,
            isDeleting: false,
            modalConnectVenue: false,
            selectedVenueID: "",
            isConnectingVenue: false,
            venueSelectedForConnection: false,
            ruckusR1Controllers: [],
        };
    }

    componentDidMount() {
        // this.getLogs();
        this.getRuckusR1Controllers();
    }

    getRuckusR1Controllers = () => {
        const body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        axios
            .post("/operatorconsole/config/listRuckusR1Controllers", body, {
                headers: { "api-version": "20260417" },
            })
            .then((response) => {
                this.setState({
                    ruckusR1Controllers:
                        response.data.RuckusR1Controllers || [],
                });
            })
            .catch((error) => {
                // Non-critical: the R1 Controller field simply won't render.
                this.setState({ ruckusR1Controllers: [] });
            });
    };

    componentDidUpdate(prevProps) {
        // Track venue selection changes when using attributeForm
        if (this.props.attributeForm && this.state.modalConnectVenue && 
            prevProps.venueID !== this.props.venueID && 
            this.props.venueID) {
            this.setState({ venueSelectedForConnection: true });
        }
    }

    modifyVenue = (venueName, key) => {
        this.setState({
            modalModifyVenue: !this.state.modalModifyVenue,
        });
        this.setState({
            venueID: key,
        });
        this.props.handleSelectChangeVenueFromList(venueName, key);
        this.props.getVenues(key);
    };

    toggleModifyVenue = () => {
        this.setState({
            modalModifyVenue: !this.state.modalModifyVenue,
        });
    };

    submitModifyKeypool = (event) => {
        event.preventDefault();
        this.setState({ update_keypool: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            KeyPoolID: this.props.keypoolInfo[this.props.keyPoolID]["key"],
            DisplayOrder: this.state.displayOrder,
        };
        axios
            .post("/networkoperatorconsole/keypools/configureKeypool", body, {
                headers: { "api-version": "20260417" },
            })
            .then(
                (response) => {
                    toast.success("Updated Keypool!", {
                        closeButton: false,
                    });
                    this.props.toggleKeypoolInfo();
                    this.setState({ update_keypool: false });
                    this.props.getOperatorInfo();
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                    this.props.toggleKeypoolInfo();
                    this.setState({ update_keypool: false });
                }
            );
    };

    getLogs = () => {
        if (window.location.pathname === "/networkdashboard") {
            let body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                IdToken: sessionStorage.getItem("IdToken"),
                KeyPoolID: this.props.keypoolInfo[this.props.keyPoolID]["key"],
            };
            axios
                .post("/networkoperatorconsole/keypools/listKeypoolLog", body, {
                    headers: { "api-version": "20260417" },
                })
                .then((response) => {
                    this.setState({
                        keyPoolLog: response.data.log,
                    });
                })
                .catch((error) => {
                    this.setState({ error: true });
                });
        }
    };

    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    toggleConfirmKeypoolDeletion = (key) => {
        this.setState({
            modalConfirmKeypoolDeletion:
                !this.state.modalConfirmKeypoolDeletion,
        });
    };

    toggleConnectVenue = () => {
        this.setState({
            modalConnectVenue: !this.state.modalConnectVenue,
            selectedVenueID: "",
            venueSelectedForConnection: false,
        });
    };

    handleVenueSelection = (event) => {
        this.setState({ 
            selectedVenueID: event.target.value,
            venueSelectedForConnection: event.target.value !== "",
        });
    };

    handleAttributeFormVenueSelection = () => {
        // Called when attributeForm venue selection changes
        this.setState({ 
            venueSelectedForConnection: this.props.venueID !== "" && this.props.venueID !== undefined,
        });
    };

    submitConnectVenue = (event) => {
        event.preventDefault();
        const venueID = this.props.attributeForm 
            ? this.props.venueID 
            : this.state.selectedVenueID;
            
        if (!venueID) {
            toast.error("Please select a venue", {
                closeButton: false,
            });
            return;
        }

        this.setState({ isConnectingVenue: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            KeyPoolID: this.props.keypoolInfo[this.props.keyPoolID]["key"],
            connectVenueID: venueID,
        };
        axios
            .post("/networkoperatorconsole/keypools/configureKeypool", body, {
                headers: { "api-version": "20260417" },
            })
            .then(
                (response) => {
                    toast.success("Venue connected successfully!", {
                        closeButton: false,
                    });
                    this.toggleConnectVenue();
                    this.setState({ isConnectingVenue: false });
                    this.props.getOperatorInfo();
                },
                (error) => {
                    toast.error(
                        error.response?.data?.message ||
                            "There was an error connecting the venue!",
                        {
                            closeButton: false,
                        }
                    );
                    this.setState({ isConnectingVenue: false });
                }
            );
    };

    confirmDeleteKeypool = () => {
        if (this.state.confirmDelete === "DELETE") {
            this.setState({
                isDeleting: true,
            });

            let body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                IdToken: sessionStorage.getItem("IdToken"),
                KeyPoolID: this.props.keypoolInfo[this.props.keyPoolID]["key"],
                deleteKeyPoolPermanently: true,
            };
            axios
                .post("/networkoperatorconsole/keypools/configureKeypool", body, {
                    headers: { "api-version": "20260417" },
                })
                .then(
                    (response) => {
                        toast.success("Keypool Deleted!", {
                            closeButton: false,
                        });
                        this.props.toggleKeypoolInfo();
                        this.setState({ isDeleting: false });
                        this.props.getOperatorInfo();
                    },
                    (error) => {
                        toast.error(error.response.data.message, {
                            closeButton: false,
                        });
                        this.setState({
                            isDeleting: false,
                        });
                        this.props.toggleKeypoolInfo();
                    }
                );
        }
    };

    render() {
        return (
            <>
                {this.state.isDeleting === true ? (
                    <div
                        className="overlay"
                        id="overlay"
                        style={{ display: "block" }}
                    >
                        <div className="overlayMessage">
                            <div
                                className="spinner-border spinner-border"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <MDBModal
                    isOpen={this.state.modalConfirmKeypoolDeletion}
                    toggle={this.toggleConfirmKeypoolDeletion}
                >
                    <MDBModalHeader toggle={this.toggleConfirmKeypoolDeletion}>
                        Confirm Keypool to be Deleted
                    </MDBModalHeader>
                    <MDBModalBody>
                        {this.props.keypoolInfo?.[this.props.keyPoolID]["ssid"]}
                        <p>
                            <strong>WARNING: THIS ACTION CANNOT BE UNDONE.</strong> This will
                            permanently delete the selected keypool. All venue associations will be removed.
                            Any keypools with an active subscription will not be deleted.
                        </p>
                        <p>
                            To confirm, please type "DELETE" into the text box below:
                        </p>
                        <input
                            required
                            name="confirmDelete"
                            id="confirmDelete"
                            className="form-control"
                            onChange={this.changeHandler}
                            placeholder="Type DELETE"
                        />
                    </MDBModalBody>
                    <MDBModalFooter>
                        <div
                            className="text-right submitButton pt-2"
                            key={this.state.theInputKey || ""}
                        >
                            <MDBBtn
                                color="primary"
                                onClick={this.confirmDeleteKeypool}
                                disabled={
                                    this.state.confirmDelete === "DELETE"
                                        ? false
                                        : true
                                }
                            >
                                {this.state.isDeleting === true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : (
                                    "Confirm"
                                )}
                            </MDBBtn>
                            <MDBBtn
                                color="primary"
                                onClick={this.toggleConfirmKeypoolDeletion}
                            >
                                Close
                            </MDBBtn>
                        </div>
                    </MDBModalFooter>
                </MDBModal>
                <MDBModal
                    isOpen={this.state.modalConnectVenue}
                    toggle={this.toggleConnectVenue}
                >
                    <MDBModalHeader toggle={this.toggleConnectVenue}>
                        Connect Venue to Keypool
                    </MDBModalHeader>
                    <MDBModalBody>
                        <form onSubmit={this.submitConnectVenue}>
                            <MDBRow>
                                <MDBCol col="12" sm="12" lg="12">
                                    <label
                                        htmlFor="venueSelection"
                                        className="black-text"
                                    >
                                        Venue to Connect
                                    </label>
                                    {this.props.attributeForm ? (
                                        this.props.attributeForm
                                    ) : (
                                        <select
                                            required
                                            name="venueSelection"
                                            id="venueSelection"
                                            className="form-control browser-default custom-select"
                                            onChange={this.handleVenueSelection}
                                            value={this.state.selectedVenueID}
                                        >
                                            <option value="">Select a venue...</option>
                                            {this.props.venueInfo &&
                                                Object.keys(this.props.venueInfo).map(
                                                    (key) => (
                                                        <option key={key} value={key}>
                                                            {this.props.venueInfo[key].VenueName ||
                                                                this.props.venueInfo[key].name}
                                                        </option>
                                                    )
                                                )}
                                        </select>
                                    )}
                                    <div className="invalid-feedback">
                                        Please select a venue.
                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </form>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn
                            color="primary"
                            onClick={this.submitConnectVenue}
                            disabled={
                                !this.state.venueSelectedForConnection ||
                                this.state.isConnectingVenue
                            }
                        >
                            {this.state.isConnectingVenue ? (
                                <div
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                >
                                    <span className="sr-only">
                                        Loading...
                                    </span>
                                </div>
                            ) : (
                                "Connect Venue"
                            )}
                        </MDBBtn>
                        <MDBBtn
                            color="primary"
                            onClick={this.toggleConnectVenue}
                        >
                            Cancel
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
                <MDBModalHeader toggle={this.props.toggleKeypoolInfo}>
                    <h4>Keypool Information</h4>
                </MDBModalHeader>
                <MDBModalBody>
                    <form
                        className="needs-validation"
                        onSubmit={this.submitModifyKeypool}
                        noValidate
                    >
                        {(() => {
                            const currentKeypool = this.props.keypoolInfo
                                ? this.props.keypoolInfo[this.props.keyPoolID]
                                : undefined;
                            if (!isR1Keypool(currentKeypool)) return null;
                            const controllerName = getR1ControllerNameForScope(
                                currentKeypool["Scope"],
                                this.state.ruckusR1Controllers
                            );
                            if (!controllerName) return null;
                            return (
                                <>
                                    <MDBRow>
                                        <MDBCol col="12">
                                            <p>
                                                <strong>R1 Controller</strong>
                                            </p>
                                            <p>{controllerName}</p>
                                        </MDBCol>
                                    </MDBRow>
                                    <br />
                                </>
                            );
                        })()}
                        <MDBRow>
                            <MDBCol col="6">
                                <p>
                                    <strong>Keypool SSID</strong>
                                </p>
                                <p>
                                    {
                                        this.props.keypoolInfo?this.props.keypoolInfo[
                                            this.props.keyPoolID
                                        ]["ssid"]:""
                                    }
                                </p>
                            </MDBCol>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    Display Order
                                </label>
                                <input
                                    required
                                    name="displayOrder"
                                    id="displayOrder"
                                    className="form-control emailInput"
                                    onChange={this.changeHandler}
                                    value={this.state.displayOrder}
                                />
                            </MDBCol>
                        </MDBRow>
                        <br />
                        <MDBRow>
                            <MDBCol col="6">
                                <p>
                                    <strong>Scope</strong>
                                </p>
                                <p>
                                    {
                                        this.props.keypoolInfo?this.props.keypoolInfo[
                                            this.props.keyPoolID
                                        ]["Scope"]:""
                                    }
                                </p>
                            </MDBCol>
                            <MDBCol col="6">
                                <p>
                                    <strong>Authentication Mechanism</strong>
                                </p>
                                <p>
                                    {
                                        this.props.keypoolInfo?this.props.keypoolInfo[
                                            this.props.keyPoolID
                                        ]["AuthenticationMechanism"]:""
                                    }
                                </p>
                            </MDBCol>
                        </MDBRow>
                        <br />
                        <MDBRow>
                            <MDBCol col="6">
                                <p>
                                    <strong>Subscribers</strong>
                                </p>
                                <div className="keypoolInfoTable">
                                    <OperatorKeypoolsSubscribersTable
                                        subscriberList={
                                         this.props.keypoolInfo?this.props.keypoolInfo[
                                                this.props.keyPoolID
                                            ]["SubscriberList"]:""
                                        }
                                    />
                                </div>
                            </MDBCol>
                            <MDBCol col="6">
                                <p>
                                    <strong>Inactive Subscribers</strong>
                                </p>
                                <div className="keypoolInfoTable">
                                    <OperatorKeypoolsSubscribersTable
                                        subscriberList={
                                         this.props.keypoolInfo?this.props.keypoolInfo[
                                                this.props.keyPoolID
                                            ]["InactiveSubscriberList"]:""
                                        }
                                    />
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <br />
                        <MDBRow>
                            <MDBCol col="12">
                                <p>
                                    <strong>Connected Venues</strong>
                                </p>
                                <div className="recentresidents">
                                    <VenuesTable
                                        venueList={
                                         this.props.keypoolInfo?this.props.keypoolInfo[
                                                this.props.keyPoolID
                                            ]["ConnectedVenueList"]:""
                                        }
                                        keyPoolID={this.props.keypoolInfo?this.props.keypoolInfo[this.props.keyPoolID]["key"]:""}
                                        onVenueDisconnected={this.props.getOperatorInfo}
                                    />
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <br />
                        {/* <MDBRow>
                            <MDBCol col="12">
                                <p>
                                    <strong>Logs</strong>
                                </p>
                                {this.state.keyPoolLog !== undefined ? (
                                    this.state.keyPoolLog.map(
                                        (value, index) => {
                                            return (
                                                <div key={index}>
                                                    <MDBRow className="mb-2">
                                                        <MDBCol>
                                                            <p>
                                                                <strong>
                                                                    Date Added:
                                                                </strong>
                                                                &nbsp;
                                                                {this.state
                                                                    .keyPoolLog[
                                                                    index
                                                                ][
                                                                    "dateAddedUTC.ISO8601"
                                                                ] !== undefined
                                                                    ? Intl.DateTimeFormat(
                                                                          "en-US",
                                                                          {
                                                                              year: "numeric",
                                                                              month: "numeric",
                                                                              day: "numeric",
                                                                              hour: "numeric",
                                                                              minute: "numeric",
                                                                          }
                                                                      ).format(
                                                                          new Date(
                                                                              this.state.keyPoolLog[
                                                                                  index
                                                                              ][
                                                                                  "dateAddedUTC.ISO8601"
                                                                              ]
                                                                          )
                                                                      )
                                                                    : ""}
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <p>
                                                                <strong>
                                                                    Function
                                                                    Name:
                                                                </strong>
                                                                &nbsp;
                                                                {
                                                                    this.state
                                                                        .keyPoolLog[
                                                                        index
                                                                    ]
                                                                        .function_name
                                                                }
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <p className="lineBreakAnywhere">
                                                                <strong>
                                                                    Event
                                                                    Message:
                                                                </strong>
                                                                &nbsp;
                                                                {
                                                                    this.state
                                                                        .keyPoolLog[
                                                                        index
                                                                    ].event
                                                                        .message
                                                                }
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <p>
                                                                <strong>
                                                                    Administrator:
                                                                </strong>
                                                                &nbsp;
                                                                {
                                                                    this.state
                                                                        .keyPoolLog[
                                                                        index
                                                                    ]
                                                                        .Administrator
                                                                }
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <p>
                                                                <strong>
                                                                    Firewall
                                                                    Source IP:
                                                                </strong>
                                                                &nbsp;
                                                                {
                                                                    this.state
                                                                        .keyPoolLog[
                                                                        index
                                                                    ]
                                                                        .FirewallSourceIP
                                                                }
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <p>
                                                                <strong>
                                                                    Source IP:
                                                                </strong>
                                                                &nbsp;
                                                                {
                                                                    this.state
                                                                        .keyPoolLog[
                                                                        index
                                                                    ].sourceIP
                                                                }
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <p>
                                                                <strong>
                                                                    Source
                                                                    Country:
                                                                </strong>
                                                                &nbsp;
                                                                {
                                                                    this.state
                                                                        .keyPoolLog[
                                                                        index
                                                                    ]
                                                                        .SourceCountry
                                                                }
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <p>
                                                                <strong>
                                                                    Source
                                                                    Viewer:
                                                                </strong>
                                                                &nbsp;
                                                                {
                                                                    this.state
                                                                        .keyPoolLog[
                                                                        index
                                                                    ]
                                                                        .SourceViewer
                                                                }
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <p>
                                                                <strong>
                                                                    Source
                                                                    Locale:
                                                                </strong>
                                                                &nbsp;
                                                                {
                                                                    this.state
                                                                        .keyPoolLog[
                                                                        index
                                                                    ]
                                                                        .SourceLocale
                                                                }
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow>
                                                        <MDBCol>
                                                            <p className="lineBreakAnywhere">
                                                                <strong>
                                                                    Source UA:
                                                                </strong>
                                                                &nbsp;
                                                                {
                                                                    this.state
                                                                        .keyPoolLog[
                                                                        index
                                                                    ].SourceUA
                                                                }
                                                            </p>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    {index + 1 !==
                                                    this.state.keyPoolLog
                                                        .length ? (
                                                        <hr />
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                            );
                                        }
                                    )
                                ) : (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                )}
                            </MDBCol>
                        </MDBRow> */}
                        <div className="text-right submitButton">
                            <MDBBtn color="danger" type="submit">
                                {this.state.update_keypool === true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : (
                                    "Save Changes"
                                )}
                            </MDBBtn>
                            <MDBBtn
                                color="primary"
                                onClick={this.toggleConnectVenue}
                            >
                                Connect Venue
                            </MDBBtn>
                            <MDBBtn
                                color="danger"
                                onClick={this.toggleConfirmKeypoolDeletion}
                                disabled={
                                 this.props.keypoolInfo?this.props.keypoolInfo[
                                        this.props.keyPoolID
                                    ]["SubscriberCount"] > 0
                                        ? true
                                        : false
                                        :""
                                }
                            >
                                Delete Keypool
                            </MDBBtn>
                            <MDBBtn
                                color="primary"
                                onClick={this.props.toggleKeypoolInfo}
                            >
                                Close
                            </MDBBtn>
                        </div>
                    </form>
                </MDBModalBody>
            </>
        );
    }
}

export default withTranslation()(OperatorInfo);
